import { Button, Container, startCheckout } from './primitives'

export function FinalCTA() {
  return (
    <section
      style={{
        padding: '140px 0 120px',
        borderTop: '1px solid var(--line)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container>
        <div style={{ textAlign: 'center', maxWidth: 900, margin: '0 auto' }}>
          <h2
            style={{
              fontFamily: 'var(--serif)',
              fontWeight: 400,
              fontSize: 'clamp(40px, 6vw, 88px)',
              lineHeight: 1.0,
              letterSpacing: '-0.03em',
              margin: 0,
            }}
          >
            Ship your site in{' '}
            <span style={{ fontStyle: 'italic', color: 'var(--accent)' }}>seven</span>{' '}
            days.
          </h2>
          <div style={{ marginTop: 48 }}>
            <Button
              variant="primary"
              size="lg"
              onClick={() => startCheckout('launch')}
              style={{ padding: '20px 32px', fontSize: 16 }}
            >
              Start your site, $1,999 <span style={{ opacity: 0.5 }}>→</span>
            </Button>
          </div>
          <div
            style={{
              marginTop: 20,
              fontSize: 13,
              color: 'var(--muted)',
              fontFamily: 'var(--mono)',
              letterSpacing: '0.04em',
            }}
          >
            STRIPE CHECKOUT · 7-DAY TURNAROUND · 48-HOUR REFUND WINDOW
          </div>
        </div>
      </Container>
    </section>
  )
}
